<template>
    <div>
        <div class="marginCenter">
            <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb">
                <div class="left flex">
                    <div class="line"></div>
                    <span>{{ query.type == 1 ? '院内报到' : '离院登记' }}</span>
                </div>
                <div class="right flex-yCenter">
                    <img src="@/assets/images/index/fanhui.png" alt="" />
                    <span
                        @click="
                            $router.push({
                                path: query.type == 1 ? '/report/index' : '/leave/index',
                                query: { applyId: [query.applyId] }
                            })
                        "
                        class="backIndex fcolor_blue2 fsize16"
                    >
                        返回
                    </span>
                </div>
            </div>
            <div class="wrap">
                <div class="title">
                    <span class="fsize32">{{ query.nodeName }}</span>
                    <div class="xian"></div>
                </div>
                <div class="wrap">
                    <div class="status s3" v-if="query.operationType == 0">无需确认</div>
                    <div class="status s2" v-else-if="query.operationType == 1">未上传</div>
                    <div class="status s2" v-else-if="query.operationType == 2">未确认</div>
                    <div class="status s1" v-else-if="query.operationType == 3">已上传</div>
                    <div class="status s1" v-else-if="query.operationType == 4">已确认</div>
                    <!-- <div class="status s3">无需上传</div> -->
                    <FileUpload
                        v-if="query.operationType == 1"
                        :isShowTip="false"
                        class="avatar-uploader pr marginRt10"
                        @on-success="uploadFile"
                        id="1"
                        :fileType="['png', 'jpg', 'jpeg', 'pdf']"
                    >
                        <template #content>
                            <el-button type="primary" class="upload">上传凭证</el-button>
                        </template>
                    </FileUpload>
                    <!-- <el-button type="primary" class="upload">上传凭证</el-button> -->
                </div>
            </div>
            <div class="description">
                <div class="text fsize16">上传说明：</div>
                <PreviewEditor :value="value"></PreviewEditor>
            </div>
        </div>
        <div class="btn">
            <el-button type="primary" @click="submit" v-if="query.operationType == 1" class="marginBom54"
                >确认提交</el-button
            >
        </div>
    </div>
</template>
<script>
//operationType 0无需上传 1上传凭证 2未确认 3已上传 4已确认
import {
    admissionConfigDetail,
    leaveConfigDetail,
    trainAdmissionNodeUploadAttCheckIn, //人事科
    trainLeaveNodeUploadLeaveNodeAtt
} from '@/utils/api';
import PreviewEditor from '@/components/previewEditor';
export default {
    components: { PreviewEditor },
    data() {
        return {
            fileList: [],
            query: {
                content: ''
            },
            value: ''
        };
    },
    created() {
        this.query = this.$route.query;
        this.query.dept = JSON.parse(this.query.dept);
        this.getContent(this.query.type, this.query.nodeKey);
    },
    // mounted() {
    //       const editor = this.$refs.editor;
    //       this.Quill = new Quill(editor, this.options);
    //       this.Quill.pasteHTML(this.currentValue);
    //       this.Quill.on("text-change", (delta, oldDelta, source) => {
    //           const html = this.$refs.editor.children[0].innerHTML;
    //           const text = this.Quill.getText();
    //           const quill = this.Quill;
    //           this.currentValue = html;
    //           this.$emit("input", html);
    //           this.$emit("on-change", { html, text, quill });
    //       });
    //       this.Quill.on("text-change", (delta, oldDelta, source) => {
    //           this.$emit("on-text-change", delta, oldDelta, source);
    //       });
    //       this.Quill.on("selection-change", (range, oldRange, source) => {
    //           this.$emit("on-selection-change", range, oldRange, source);
    //       });
    //       this.Quill.on("editor-change", (eventName, ...args) => {
    //           this.$emit("on-editor-change", eventName, ...args);
    //       });
    //   },
    methods: {
        // 上传
        uploadFile(res) {
            this.fileUrl = res.url;
        },
        getContent(type, nodeKey) {
            // 报到
            if (type == 1) {
                console.log(this.query);
                admissionConfigDetail(nodeKey, this.query.applyId).then((res) => {
                    let a = res.data.content.content.replace('{{principal}}', this.query.dept.principal);
                    a = a.replace('{{phoneNumber}}', this.query.dept.phoneNumber);
                    a = a.replace('{{registrationLocation}}', this.query.dept.registrationLocation);
                    a = a.replace('{{registrationTime}}', this.query.dept.registrationTime);
                    this.value = a;
                });
            }
            // 离院
            else {
                leaveConfigDetail(nodeKey).then((res) => {
                    let a = res.data.content.content.replace('{{principal}}', this.query.dept.principal);
                    a = a.replace('{{phoneNumber}}', this.query.dept.phoneNumber);
                    a = a.replace('{{registrationLocation}}', this.query.dept.registrationLocation);
                    a = a.replace('{{registrationTime}}', this.query.dept.registrationTime);
                    this.value = a;
                });
            }
        },
        // 提交
        submit() {
            if (this.fileUrl) {
                if (this.query.type == 1) {
                    trainAdmissionNodeUploadAttCheckIn({
                        nodeId: this.query.nodeId,
                        attachmentAddress: this.fileUrl
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 1000);
                        }
                    });
                } else {
                    trainLeaveNodeUploadLeaveNodeAtt({
                        nodeId: this.query.nodeId,
                        attachmentAddress: this.fileUrl
                    }).then((res) => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            setTimeout(() => {
                                this.$router.go(-1);
                            }, 1000);
                        }
                    });
                }
            } else {
                this.$message.error('请先上传凭证后再提交');
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.backIndex:hover {
    cursor: pointer;
}

.applyType {
    margin-top: 110px;
}

.remark {
    margin: 32px 0 110px 0;
}

.el-button--primary {
    width: 300px;
    height: 60px;
    background: #ffffff;
    color: #2d53c8;
    border-radius: 5px;
    border: 4px solid #2d53c8;
}

.wrap {
    margin-top: 68px;
    text-align: center;

    .title {
        text-align: center;

        &:first-child {
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
        }

        .xian {
            width: 74px;
            height: 6px;
            background: #2d53c8;
            border-radius: 5px;
            margin: 5px auto 0;
        }
    }

    .status {
        margin-bottom: 15px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1eb28f;
        line-height: 33px;
    }

    .s2 {
        color: #eb5b00;
    }

    .s3 {
        color: #999999;
    }

    .upload {
        width: 225px;
        height: 60px;
        background: #ffffff;
        border-radius: 5px;
        border: 4px solid #2d53c8;
    }
}

.description {
    margin-top: 58px;

    .text {
        font-size: 16px;
    }

    .info {
        line-height: 1.5;
        text-align: center;
    }
}

.btn {
    margin-top: 128px;
    text-align: center;

    button {
        background-color: #2d53c8;
        color: #fff;
        font-size: 22px;
        letter-spacing: 2px;
    }
}
</style>
